import { boot } from 'quasar/wrappers'

import VueAuth from '@websanova/vue-auth/dist/v2/vue-auth.common'
import auth from '@websanova/vue-auth/dist/drivers/auth/bearer'
import http from '@websanova/vue-auth/dist/drivers/http/axios.1.x'
import router from '@websanova/vue-auth/dist/drivers/router/vue-router.2.x'

export default boot(({ router: appRouter, Vue, urlPath }) => {
  Vue.use(VueAuth, {
    plugins: {
      http: Vue.axios,
      router: appRouter
    },
    drivers: {
      auth,
      http,
      router
    }
  })
})
